module.exports = __webpack_public_path__ + "files/e8fcb80ae47192c16eab997bfd6afe10.png";